import { render, staticRenderFns } from "./LaudosAvaliacao.vue?vue&type=template&id=2879d8f9&"
import script from "./LaudosAvaliacao.vue?vue&type=script&lang=js&"
export * from "./LaudosAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports